// What's New's registration (docs/features/canary-channel.md): the window `whatsnew` and Home's item.
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'

registerWindow('whatsnew', { module: () => import('./whatsnew.js'), css: 'windows/whatsnew/whatsnew.css', title: () => "What's New", place: ['home', 'front'] })
registerHomeItem({ id: 'whatsnew', label: "What's New", symbol: 'sparkles', needs: '', section: 'toolbar', order: 60 })
